export default import.meta.ROLLDOWN_FILE_URL_5$sevU9Dyn7xl0c_7zlKpg